import { TableCell, TableRow } from '@/components/ui';
import { SearchX } from 'lucide-react';

/**
 * Empty state displayed in the table when filters don't match any results.
 * This keeps the toolbar visible so users can adjust their filters.
 */
const EmptyFilteredState = () => {
    return (
        <TableRow>
            <TableCell colSpan={5} className="h-32 text-center">
                <div className="flex flex-col items-center justify-center gap-2">
                    <div className="rounded-full bg-muted p-3">
                        <SearchX className="w-6 h-6 text-muted-foreground" />
                    </div>
                    <div>
                        <p className="text-sm font-medium text-foreground">
                            Aucun paiement ne correspond à vos filtres
                        </p>
                        <p className="text-xs text-muted-foreground mt-1">
                            Essayez de modifier vos critères de recherche pour voir plus de résultats.
                        </p>
                    </div>
                </div>
            </TableCell>
        </TableRow>
    );
};

export default EmptyFilteredState;

